<template>
  <div>
    <div class="q-toolbar">
      <div class="q-toolbar-buttons">
        <q-button
          v-show="hasSelection"
          class="q-toolbar-btn"
          :style="firstButtonStyle"
          @click="replyTasks"
        >
          <font-awesome-icon
            v-if="multipleSelection && multipleSelection.length < 2"
            :icon="['fas', 'reply']"
          />
          <font-awesome-icon
            v-else
            :icon="['fas', 'reply-all']"
          />
        </q-button>
        <q-button
          v-show="hasSelection"
          class="q-toolbar-btn"
          @click="forwardTasks"
        >
          <font-awesome-icon
            v-if="multipleSelection && multipleSelection.length < 2"
            :icon="['fas', 'share']"
          />
          <font-awesome-icon
            v-else
            :icon="['fas', 'share']"
          />
        </q-button>

        <q-button
          class="q-toolbar-btn"
          @click.prevent="limitationDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'filter']" />
        </q-button>
        <q-button
          class="q-toolbar-btn"
          @click="refreshRows"
        >
          <font-awesome-icon :icon="['fas', 'sync-alt']" />
        </q-button>
        <q-button
          v-if="getPermissions('STRUCTURE')"
          class="q-toolbar-btn"
          @click.prevent="structureDialog = true"
        >
          <font-awesome-icon :icon="['fas', 'cog']" />
        </q-button>

        <q-dropdown
          v-show="hasSelection"
          trigger="click"
          class="q-toolbar-btn"
          @command="runMethods"
        >
          <q-button>
            <span>{{ this.$qt('listStructure.actionCaption') }}</span>
            <i class="q-icon-arrow-down q-icon--right" />
          </q-button>
          <q-dropdown-menu slot="dropdown">
            <q-dropdown-item
              v-for="method in listStructure.methods"
              :key="method.key"
              :command="method"
            >
              {{ method.caption }}
            </q-dropdown-item>
          </q-dropdown-menu>
        </q-dropdown>

        <q-input
          v-model="word"
          :placeholder="this.$qt('listStructure.searchPlaceHolder')"
          :style="searchStyle"
        >
          <q-button
            slot="append"
            type="info"
            icon="q-icon-search"
          />
        </q-input>
      </div>
    </div>

    <q-panel>
      <q-table
        stripe
        :data="filteredData"
        :width="listStructure.width"
        sum-text="----"
        :empty-text="this.$qt('listStructure.emptyList')"
        @row-click="rowSelected"
        @selection-change="handleSelectionChange"
      >
        <q-table-column
          type="selection"
          width="55"
        />
        <q-table-column
          property="startTime"
          sortable
          :label="this.$qt('taskList.startTimeCaption')"
          width="200"
        />
        <q-table-column
          property="loaded"
          width="55"
        />

        <q-table-column
          v-for="col in listStructure.columns"
          :key="col.key"
          :type="col.type"
          :sortable="col.sortable === true"
          :label="col.caption"
          :width="col.width === 0 ? undefined : col.width"
        >
          <template slot-scope="scope">
            <template v-if="col.fieldType === 'DatePicker'">
              <span
                style="direction: ltr"
              >{{ getDate(scope.row[col.key]) }}</span>
            </template>
            <template v-else-if="col.fieldType === 'CheckBox'">
              <font-awesome-icon
                v-if="scope.row[col.key] === true"
                icon="check"
              />
              <font-awesome-icon
                v-else
                icon="times"
              />
            </template>
            <template v-else-if="col.fieldType === 'model'">
              <span>AMIN</span>
            </template>
            <template v-else>
              <span>{{ scope.row[col.key] }}</span>
            </template>
          </template>
        </q-table-column>
      </q-table>

      <q-pagination
        :page-size="listStructure.itemInPage"
        :pager-count="11"
        :total="modelsQty"
        layout="prev ,pager , next"
        :current-page.sync="currentPage"
        :next-text="this.$qt('listStructure.pagination.nextText')"
        :prev-text="this.$qt('listStructure.pagination.prevText')"
        background
        @current-change="changePage"
      />
    </q-panel>

    <q-dialog
      :title="this.$qt('listStructure.settingTitle')"
      width="50%"
      :visible.sync="structureDialog"
    >
      <list-structure-detail
        v-model="listStructure"
        @close="structureDialog = false"
      />
    </q-dialog>

    <q-dialog
      :title="this.$qt('listStructure.limitationTitle')"
      width="50%"
      :visible.sync="limitationDialog"
      append-to-body
    >
      <div v-if="limitationStructure">
        <q-form
          ref="limitationForm"
          :model="rangeModel"
          :rules="rangeRules"
          labq-width="150px"
        >
          <q-form-generator
            v-model="rangeModel"
            :form-structure="limitationStructure"
          />
        </q-form>
      </div>
      <div v-else>
        <span>{{ this.$qt('listStructure.limitationNotSet') }}</span>
      </div>

      <span slot="footer">
        <q-button
          type="primary"
          @click="limit"
        >{{ this.$qt('listStructure.confirmLimitation') }}</q-button>
        <q-button @click="limitationDialog = false">{{ this.$qt('listStructure.rejectLimitation') }}</q-button>
      </span>
    </q-dialog>
  </div>
</template>

<script>

  import listMixin from '../../../../q-components/mixins/listMixin'
  import listStructureDetail from '../../structures/listStructureDetail';
  import caller from '../../../../q-components/q-caller';


  export default {
    name: 'QTaskList',
    components: {
      'list-structure-detail': listStructureDetail,
    },
    mixins: [listMixin],
    props: {
      taskKey: {required: true, type: String}
    },
    data() {
      return {
        limitationStructure: undefined,
        limitationDialog: false,
        rangeModel: {}
      };
    },
    methods: {

      initialize(data) {
        this.models = data.models;
        this.listStructure = data.listStructure;
        this.pageQty = data.pageQty;
        this.modelsQty = data.modelsQty;

        this.currentPage = 1;
        this.rangeModel = {};

        this.$delegate('structure', 'fetchFormStructure', {
          structureKey: this.listStructure.key + 'Limitation'
        }).then((response) => {
          this.limitationStructure = response.result;
        }).catch(() => {
        });

        this.$eventHub.$emit("onPageChanging", {
          caption: this.listStructure.caption,
          note: this.listStructure.note
        })
      },

      replyTasks(){},
      forwardTasks(){},

      refreshRows() {
        this.rangeModel = {};
        this.$delegate('bpmInstance', 'getUserTaskList', {
          range: this.rangeModel,
          itemInPage: this.listStructure.itemInPage,
          page: 1
        }).then((res) => {
          this.limitationDialog = false;
          this.currentPage = 1;
          this.models = res.result.models;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },
      limit() {
        this.$delegate('bpmInstance', 'getUserTaskList', {
          range: this.rangeModel,
          itemInPage: this.listStructure.itemInPage,
          page: 1
        }).then((res) => {
          this.limitationDialog = false;
          this.currentPage = 1;
          this.models = res.result.models;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },
      changePage() {
        this.$delegate('bpmInstance', 'getUserTaskList',  {
          taskKey: this.taskKey,
          range: this.rangeModel,
          itemInPage: this.listStructure.itemInPage,
          page: this.currentPage
        }).then((res) => {
          this.limitationDialog = false;
          this.models = res.result.models;
          this.pageQty = res.result.pageQty;
          this.modelsQty = res.result.itemsQty;
        }).catch(() => {
        });
      },
      rowSelected(row) {
        let params = {
          taskKey: this.taskKey,
          instanceId: row.instanceId,
          activityInstanceId: row.id
        };
        this.$router.push({name: 'task', params: params});
      },
      runMethods(method) {
        this.$delegate(method.plugin, method.delegate, {
          models: this.multipleSelection
        }).then((res) => {
          this.$notify({
            title: this.$qt('listStructure.methodSuccessTitle'),
            message:   res.message,
            type: 'success'
          });
        }).catch(() => {
        });
      },
    },
    beforeRouteEnter(to, from, next) {
      caller.delegate('structure', 'fetchListStructure', {
        structureKey: to.params.taskKey
      }).then((structureResponse) => {
        let structure = structureResponse.result;
        caller.delegate('bpmInstance', 'getUserTaskList', {
          taskKey: to.params.taskKey,
          range: null,
          itemInPage: structure.itemInPage,
          page: 1
        }).then((res) => {
          next(vm => vm.initialize({
            listStructure: structure,
            models: res.result.models,
            page: res.result.page,
            pageQty: res.result.pageQty,
            modelsQty: res.result.itemsQty,
          }));
        }).catch(() => {
        });
      }).catch(() => {
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.$delegate('structure', 'fetchListStructure', {
        structureKey: to.params.taskKey
      }).then((structureResponse) => {
        let structure = structureResponse.result;
        this.$delegate('bpmInstance', 'getUserTaskList', {
          taskKey: to.params.taskKey,
          range: null,
          itemInPage: structure.itemInPage,
          page: 1
        }).then((res) => {
          this.initialize({
            listStructure: structure,
            models: res.result.models,
            page: res.result.page,
            pageQty: res.result.pageQty,
            modelsQty: res.result.itemsQty,
          });
          next();
        }).catch(() => {
        });
      }).catch(() => {
      });
    }
  }
</script>

<style scoped>
  .q-toolbar {
    margin: 20px;
  }

  .q-toolbar-buttons {
    display: -webkit-box;
    display: -ms-flexbox;

    display: flex;
    line-height: 15px;
  }

  .q-toolbar-btn {
    margin-left: 3px;
    margin-right: 3px;
  }
</style>
